import api from '../api/font-api';

export default {
    getFontList(params) {
        return new Promise((resolve, reject) => {
            api.getFontList(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    addFont(data) {
        return new Promise((resolve, reject) => {
            api.addFont(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    parseAndSaveFont (params) {
        return new Promise((resolve, reject) => {
            api.parseAndSaveFont(params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    parseFont (params) {
        return new Promise((resolve, reject) => {
            api.parseFont(params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        })
    },
    addFontByProject(params) {
        return new Promise((resolve, reject) => {
            api.addFontByProject(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    addFontByAdmin(params) {
        return new Promise((resolve, reject) => {
            api.addFontByAdmin(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    updateFont(data) {
        return new Promise((resolve, reject) => {
            api.updateFont(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    updateFontCover(dataList) {
        return new Promise((resolve, reject) => {
            api.updateFontCover(dataList).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    delFont(ids) {
        return new Promise((resolve, reject) => {
            api.delFont(ids).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    getMakerList() {
        return new Promise((resolve, reject) => {
            api.getMakerList().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    getTypeList() {
        return new Promise((resolve, reject) => {
            api.getTypeList().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    getProjectFonts(params) {
        return new Promise((resolve, reject) => {
            api.getProjectFonts(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    delProjectFont(projectId,fontIds) {
        return new Promise((resolve, reject) => {
            api.delProjectFont(projectId, fontIds).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    setProjectFont(fontIds, projectId, overwrite) {
        return new Promise((resolve, reject) => {
            api.setProjectFont(fontIds, projectId, overwrite).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getFontsByProjectId(projectId, nameList) {
        nameList && nameList.forEach((str, idx) => {
            nameList[idx] = window.encodeURIComponent(str);
        })
        return new Promise((resolve, reject) => {
            api.getFontsByProjectId(projectId, nameList).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    uploadFonts(files, callback) {
        return new Promise((resolve, reject) => {
            api.uploadFonts(files, callback,).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getFontListByNames(projectId, nameList){
        nameList && nameList.forEach((str, idx) => {
            nameList[idx] = window.encodeURIComponent(str);
        })
        return new Promise((resolve, reject) => {
            api.getFontListByNames(projectId, nameList).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    addFontName(data) {
        return new Promise((resolve, reject) => {
            api.addFontName(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    updateFontAlias(data) {
        return new Promise((resolve, reject) => {
            api.updateFontAlias(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    updateFontUrl(data, projectId) {
        return new Promise((resolve, reject) => {
            api.updateFontUrl(data, projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getRecommendFonts (data) {
        return new Promise((resolve, reject) => {
            api.getRecommendFonts(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        })
    }
}